import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import operatorApi from '../utils/operatorApi';
import toast from 'react-hot-toast';

const inputStyle = {
  width: '100%', padding: '10px 12px', borderRadius: 8,
  background: 'var(--navy)', border: '1px solid var(--border-2)',
  color: 'var(--text-1)', fontSize: 14, fontFamily: 'Inter, sans-serif',
};

export default function OperatorAuthPage() {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ company_name:'', email:'', password:'', country:'' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await operatorApi.post(`/operator/${mode}`, form);
      localStorage.setItem('evapp_operator_token', res.data.token);
      toast.success(mode === 'login' ? 'Welcome back!' : 'Operator account created!');
      navigate('/operator/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Something went wrong');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 16px',
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 48, height: 48, borderRadius: 14,
            background: 'linear-gradient(135deg, #00D4AA, #0099FF)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 24, margin: '0 auto 12px',
          }}>🏢</div>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>Operator Portal</h1>
          <p style={{ fontSize: 13, color: 'var(--text-3)', marginTop: 4 }}>
            Manage your EV charging network on ChargeSure
          </p>
        </div>

        <div style={{ background: 'var(--slate)', border: '1px solid var(--border)', borderRadius: 16, padding: '28px 24px' }}>
          <div style={{ display: 'flex', background: 'var(--navy)', borderRadius: 10, padding: 3, marginBottom: 24 }}>
            {['login','register'].map(m => (
              <button key={m} onClick={() => setMode(m)} style={{
                flex: 1, padding: '8px 0', borderRadius: 8, border: 'none',
                background: mode === m ? 'var(--slate)' : 'transparent',
                color: mode === m ? 'var(--text-1)' : 'var(--text-3)',
                fontSize: 13, fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s',
              }}>
                {m === 'login' ? 'Log In' : 'Sign Up'}
              </button>
            ))}
          </div>

          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {mode === 'register' && (
              <div>
                <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>Company / Network Name</label>
                <input placeholder="e.g. Fastned, Statiq" required value={form.company_name} onChange={e => setForm({...form, company_name: e.target.value})} style={inputStyle} />
              </div>
            )}
            <div>
              <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>Work Email</label>
              <input type="email" required placeholder="you@yourcompany.com" value={form.email} onChange={e => setForm({...form, email: e.target.value})} style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>Password</label>
              <input type="password" required minLength={6} placeholder="Min. 6 characters" value={form.password} onChange={e => setForm({...form, password: e.target.value})} style={inputStyle} />
            </div>
            {mode === 'register' && (
              <div>
                <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 5 }}>Primary Country</label>
                <select value={form.country} onChange={e => setForm({...form, country: e.target.value})} style={inputStyle}>
                  <option value="">Select country</option>
                  {[['IN','India'],['DE','Germany'],['NL','Netherlands'],['FR','France'],['GB','United Kingdom'],['US','United States']].map(([v,l]) => (
                    <option key={v} value={v}>{l}</option>
                  ))}
                </select>
              </div>
            )}
            <button type="submit" disabled={loading} style={{
              marginTop: 4, padding: '12px 0', borderRadius: 10, border: 'none',
              background: 'var(--teal)', color: 'var(--navy)',
              fontWeight: 700, fontSize: 14, cursor: 'pointer', opacity: loading ? 0.7 : 1,
            }}>
              {loading ? 'Please wait…' : mode === 'login' ? 'Log In' : 'Create Operator Account'}
            </button>
          </form>

          {mode === 'register' && (
            <p style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 14, textAlign: 'center', lineHeight: 1.5 }}>
              After signup, submit a charger claim and we'll review and link your fleet.
            </p>
          )}
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: 'var(--text-3)' }}>
          EV driver?{' '}
          <Link to="/login" style={{ color: 'var(--teal)', textDecoration: 'none' }}>Sign in here →</Link>
        </p>
      </div>
    </div>
  );
}
